/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { Company } from "./Company";
// @ts-ignore
import { RequestExternalEntityData } from "./RequestExternalEntityData";
// @ts-ignore
import { RequestMeta } from "./RequestMeta";
// @ts-ignore
import { RequestStats } from "./RequestStats";
// @ts-ignore
import { Standard } from "./Standard";
// @ts-ignore
import { Team } from "./Team";
// @ts-ignore
import { User } from "./User";

/**
 *
 * @export
 * @interface RequestSummary
 */
export interface RequestSummary {
    /**
     *
     * @type {number}
     * @memberof RequestSummary
     */
    completion_days?: number;
    /**
     * Alias for form_questions_filled
     * @type {number}
     * @memberof RequestSummary
     */
    form_filled: number;
    /**
     * Portion of visible questions filled
     * @type {number}
     * @memberof RequestSummary
     */
    form_percentage_filled: number;
    /**
     * Number of questions in the form
     * @type {number}
     * @memberof RequestSummary
     */
    form_question_count: number;
    /**
     * Number of questions in the form without taking visibility into account
     * @type {number}
     * @memberof RequestSummary
     */
    form_question_count_ignore_visibility: number;
    /**
     * Number of questions that have all responses filled
     * @type {number}
     * @memberof RequestSummary
     */
    form_questions_completely_filled: number;
    /**
     * Number of questions that are either completely or partially filled
     * @type {number}
     * @memberof RequestSummary
     */
    form_questions_filled: number;
    /**
     * Number of questions that have at least one response and not all responses filled
     * @type {number}
     * @memberof RequestSummary
     */
    form_questions_partially_filled: number;
    /**
     * Number of responses in the form
     * @type {number}
     * @memberof RequestSummary
     */
    form_response_count: number;
    /**
     * Number of responses in the form without taking visibility into account
     * @type {number}
     * @memberof RequestSummary
     */
    form_response_count_ignore_visibility: number;
    /**
     * Number of responses filled in the form
     * @type {number}
     * @memberof RequestSummary
     */
    form_responses_filled: number;
    /**
     *
     * @type {number}
     * @memberof RequestSummary
     */
    form_score: number;
    /**
     * Visibility flag for form score
     * @type {boolean}
     * @memberof RequestSummary
     */
    form_score_visible: boolean;
    /**
     * Alias for form_question_count
     * @type {number}
     * @memberof RequestSummary
     */
    form_total: number;
    /**
     * When was the entity created
     * @type {Date}
     * @memberof RequestSummary
     */
    created_at: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof RequestSummary
     */
    updated_at: Date;
    /**
     * The day when the VRM accepted the request. This will be set internally and         only when the VRM status changes from in progress to accepted
     * @type {Date}
     * @memberof RequestSummary
     */
    accepted_date?: Date;
    /**
     * User can view form data
     * @type {boolean}
     * @memberof RequestSummary
     */
    can_view_data: boolean;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    code: string;
    /**
     *
     * @type {Date}
     * @memberof RequestSummary
     */
    due_date?: Date;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    form_id: string;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    form_name: string;
    /**
     *
     * @type {Array<string>}
     * @memberof RequestSummary
     */
    form_roles: Array<RequestSummaryFormRolesEnum>;
    /**
     *
     * @type {number}
     * @memberof RequestSummary
     */
    history_count: number;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    id: string;
    /**
     *
     * @type {boolean}
     * @memberof RequestSummary
     */
    is_internal: boolean;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    message: string;
    /**
     *
     * @type {number}
     * @memberof RequestSummary
     */
    revision_count: number;
    /**
     *
     * @type {string}
     * @memberof RequestSummary
     */
    risk_note: string;
    /**
     *
     * @type {Standard}
     * @memberof RequestSummary
     */
    standard: Standard;
    /**
     * Current request status
     * @type {string}
     * @memberof RequestSummary
     */
    status: RequestSummaryStatusEnum;
    /**
     * Status of the request after it will be unarchived
     * @type {string}
     * @memberof RequestSummary
     */
    status_before_archived: RequestSummaryStatusBeforeArchivedEnum;
    /**
     * When the request was first opened by target (vendor).
     * @type {Date}
     * @memberof RequestSummary
     */
    target_opened_at?: Date;
    /**
     *
     * @type {boolean}
     * @memberof RequestSummary
     */
    was_scheduled: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RequestSummary
     */
    is_vendor: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RequestSummary
     */
    is_vrm: boolean;
    /**
     *
     * @type {Company}
     * @memberof RequestSummary
     */
    source: Company;
    /**
     *
     * @type {Team}
     * @memberof RequestSummary
     */
    source_team?: Team;
    /**
     *
     * @type {User}
     * @memberof RequestSummary
     */
    source_user: User;
    /**
     *
     * @type {Company}
     * @memberof RequestSummary
     */
    target: Company;
    /**
     *
     * @type {Team}
     * @memberof RequestSummary
     */
    target_team?: Team;
    /**
     *
     * @type {User}
     * @memberof RequestSummary
     */
    target_user: User;
    /**
     * Current vrm view status
     * @type {string}
     * @memberof RequestSummary
     */
    vrm_view_status: RequestSummaryVrmViewStatusEnum;
}




/**
* @export
* @enum {string}
*/
export enum RequestSummaryFormRolesEnum {
    OWNER = 'OWNER',
    VENDOR = 'VENDOR',
    VENDORPROXY = 'VENDOR_PROXY',
    VRM = 'VRM',
    VRMPROXY = 'VRM_PROXY',
    OTHER = 'OTHER'
}
/**
* @export
* @enum {string}
*/
export enum RequestSummaryStatusEnum {
    ACCEPTED = 'ACCEPTED',
    ARCHIVED = 'ARCHIVED',
    CANCELED = 'CANCELED',
    CREATED = 'CREATED',
    UNARCHIVED = 'UNARCHIVED',
    VENDORINPROGRESS = 'VENDOR_IN_PROGRESS',
    VRMINPROGRESS = 'VRM_IN_PROGRESS'
}
/**
* @export
* @enum {string}
*/
export enum RequestSummaryStatusBeforeArchivedEnum {
    ACCEPTED = 'ACCEPTED',
    ARCHIVED = 'ARCHIVED',
    CANCELED = 'CANCELED',
    CREATED = 'CREATED',
    UNARCHIVED = 'UNARCHIVED',
    VENDORINPROGRESS = 'VENDOR_IN_PROGRESS',
    VRMINPROGRESS = 'VRM_IN_PROGRESS'
}
/**
* @export
* @enum {string}
*/
export enum RequestSummaryVrmViewStatusEnum {
    VENDORAPPROVED = 'VENDOR_APPROVED',
    VENDORDECLINED = 'VENDOR_DECLINED',
    VENDORINITIAL = 'VENDOR_INITIAL',
    VRMREQUESTED = 'VRM_REQUESTED'
}


